// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';
import { setUrlByProjectCode } from '@/utils/routerBeforeEnter';

const route: SiteRouteItem = {
  path: '/after-sale',
  component: Layout,
  name: PermissionPageKey.AfterSale,
  meta: {
    title: 'workplace.platform_app.apps.after_sale.title',
    icon: 'carbon:sales-ops',
    iconCls: 'bg-green-500',
    // ctc-ai 停库期间：售后反馈管理仅管理员可见（恢复后移除本行）
    roles: ['admin'],
  },
  redirect: '/after-sale/after-sales-analysis', // 默认首页子路由
  children: [
    // {
    //   path: 'dashboard',
    //   name: PermissionPageKey.AfterSaleDashboard,
    //   component: () => import('../pages/dashboard/index.vue'),
    //   meta: { title: '看板', icon: 'material-symbols:dashboard' },
    // },
    {
      path: 'after-sales-analysis',
      name: PermissionPageKey.AFTER_SALES_ANALYSIS,
      component: () => import('../pages/after-sales-analysis/index.vue'),
      meta: {
        title: 'workplace.platform_app.apps.after_sale.after_sales_analysis.title',
        icon: 'material-symbols:dashboard',
      },
    },
    {
      path: 'after-sales-data',
      name: PermissionPageKey.AFTER_SALES_DATA,
      component: () => import('../pages/after-sales-data/index.vue'),
      meta: {
        title: 'workplace.platform_app.apps.after_sale.after_sales_data.title',
        icon: 'material-symbols:dashboard',
      },
    },
    {
      path: 'feedback',
      name: PermissionPageKey.FEEDBACK_MANAGEMENT,
      component: () => import('../pages/feedback/index.vue'),
      meta: {
        title: 'workplace.platform_app.apps.after_sale.feedback.title',
        icon: 'material-symbols:dashboard',
      },
      // 飞书插件传参通过路由导航守卫做拦截和重新设值
      beforeEnter: (to, from, next) => {
        setUrlByProjectCode(to, next, 'projectId');
      },
    },
    // {
    //   path: 'sentiment-analysis',
    //   name: PermissionPageKey.PUBLIC_OPINION_ANALYSIS,
    //   component: () => import('../pages/sentiment-analysis/index.vue'),
    //   meta: { title: '舆情分析', icon: 'material-symbols:dashboard' },
    // },
  ],
};

export default route;
